// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iilj","comment":"styles_comment__34ZqG"};